import MobileDetect from 'mobile-detect'

export default defineNuxtPlugin(() => {
  const { setDevice } = useDevice()

  const md = new MobileDetect(navigator.userAgent)
  const isMobile = md.phone() !== null || md.mobile() === 'UnknownMobile'
  const isTablet = md.tablet() !== null || md.mobile() === 'UnknownTablet'
  const isDesktop = !isMobile && !isTablet

  setDevice({
    isMobile,
    isTablet,
    isDesktop
  })
})